module.exports = __webpack_public_path__ + "static/media/Indexia.fb955b76.svg";